module.exports = __webpack_public_path__ + "static/media/visibility.75fc452b.svg";